import React from 'react';
import './index.styl';
import classnames from 'classnames';
import {DIRECTION} from 'common/js/params';

const clzpre = 'env-digital-property';

const formatValue = (c) => {
    if (c.key === 'wind_power') {
        return c.value;
    }
    if (c.key === 'wind_direction') {
        return `${DIRECTION[c.value]}风`;
    }
    return typeof c.value === 'number' ? c.value.toFixed(2) : '-';
}

export default (props) => {
    const {data} = props;
    const {children} = data;
    return (
        <section className={clzpre}>
            {children.map((c) => {
                return (
                    <div key={c.key}>
                        <h4>{c.name}{c.unit ? `(${c.unit})` : ''}</h4>
                        <p
                            className={classnames({
                                'alarm': c.alarm === true
                            })}
                        >{formatValue(c)}</p>
                    </div>
                );
            })}
            <footer>{data.name}</footer>
        </section>
    );
}
